import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'

export const useFindingsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'findings')

export const useReviewRequestsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'review_requests')
